import {useCallback, useEffect, useState} from "react";
import {BookablesService} from "@hps/hops-sdk-js";
import {Select} from "Components/Select";
import useAuth from "Hooks/useAuth";
import {useFetch} from "Hooks/useFetch";

/**
 * Bookable unit picker
 *
 * @param {Object} props
 * @return {ReactNode}
 */
export const BookablesUnitPicker = props => {

	const {
		showNullOption,
		isOptionDisabled,
		onlyIncludeBookableByAuthUser,
		value
	} = props;

	const {hasPermission} = useAuth();

	const [options, setOptions] = useState([]);

	const [initialValue] = useState(value);

	const {data, loading, error} = useFetch({
		fn: () => (!onlyIncludeBookableByAuthUser ? BookablesService.getUnits() : BookablesService.getUnitsBookableByAuthUser()),
		dep: []
	});

	const getIsOptionDisabled = useCallback((unit, parentLevel) => {
		if (onlyIncludeBookableByAuthUser && !hasPermission(472, unit.Type?.Id) && !hasPermission(473, unit.Type?.Id) && (unit.Id !== initialValue.Id)) return true;
		else return isOptionDisabled?.(unit, parentLevel);
	}, [hasPermission, initialValue, isOptionDisabled, onlyIncludeBookableByAuthUser]);

	useEffect(() => {

		if (data || initialValue) {

			const units = [];
			if (initialValue) {
				units.push(initialValue);
			}
			if (data) {
				units.push(...data);
			}

			const options = [];

			if (showNullOption) {
				options.push({
					label: "(None)",
					value: null
				});
			}

			const flattenedUnits = BookablesService.getUnitsTreeLeavesFlattened(units);
			for (const unit of flattenedUnits) {
				const parentLevel = BookablesService.getUnitParentLevel(unit);

				options.push({
					label: `${"-".repeat((parentLevel * 2))}${unit.Name}`,
					value: unit,
					disabled: getIsOptionDisabled(unit, parentLevel)
				});
			}

			setOptions(options);

		}

	}, [data, showNullOption, initialValue, getIsOptionDisabled]);

	return (
		<Select
			disabled={props.disabled}
			placeholder={props.placeholder}
			loading={loading}
			error={!!error}
			name={props.name}
			onChange={props.onChange}
			options={options}
			required={props.required}
			getOptionValue={o => o.value?.Id}
			value={value?.Id} />
	);

};
